import React from 'react';
import { NavBar, NavBarProps } from '../NavBar';
import { EventInfoFragmentFragment, EventPageFragment } from '@graphql/generated';
import { StyledRoot, StyledTitle, styles } from './Header.styles';
import { EventTitleProps } from '@apps/guest/packages/layout-engine/components/EventTitle/EventTitle.types';
import { ButtonV2, TextV2 } from '@withjoy/joykit';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { useTranslation } from '@shared/core/i18n';
import { isInIframe } from '@shared/utils/isInIframe';
import { NavbarEventPropsInterface } from '@apps/guest/packages/layout-engine/layouts/layout.types';
export interface HeaderProps
  extends Readonly<{
    eventHandle: string;
    info: EventInfoFragmentFragment;
    pages: ReadonlyArray<EventPageFragment>;
    navBarVariant: NavBarProps['variant'];
    applicatorProp: object;
    eventTitleMode: EventTitleProps['mode'];
    eventTitleMax: number;
    handleMenuClicked?: (item: string) => void;
    handleEditEventClicked?: () => void;
    eventProps: NavbarEventPropsInterface;
  }> {}

const Header: React.FC<HeaderProps> = ({
  applicatorProp,
  eventHandle,
  eventTitleMode,
  eventTitleMax,
  info,
  pages,
  navBarVariant,
  handleMenuClicked,
  handleEditEventClicked,
  eventProps,
  ...restProps
}) => {
  const { isAdmin } = useEventUserRole();

  const { t2 } = useTranslation('eventMenu');
  const editEventText = t2('editEvent');
  const isPreviewing = isInIframe();

  return (
    <StyledRoot {...restProps} position={'relative'} minHeight={[291, 200, null, 'initial']} {...applicatorProp}>
      <StyledTitle __css={styles.title} data-testid="header-title">
        <TextV2 typographyVariant={['display4', 'display6']}>{info.eventDisplayName}</TextV2>
      </StyledTitle>
      {isAdmin && !isPreviewing && navBarVariant === 'inline' && (
        <ButtonV2
          onClick={handleEditEventClicked}
          intent="primary"
          size="sm"
          typographyVariant="button1"
          variant="outline"
          position="absolute"
          top="19px"
          right="16px"
          as="a"
          href={`/${eventHandle}/edit`}
        >
          {editEventText}
        </ButtonV2>
      )}
      <NavBar
        handleMenuClicked={handleMenuClicked}
        title={info.eventDisplayName}
        variant={navBarVariant}
        data-testid={'header-nav'}
        eventHandle={eventHandle}
        pages={pages}
        eventProps={eventProps}
      />
    </StyledRoot>
  );
};

Header.displayName = 'Header';

export { Header };
